<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8889 9.77777L18.6667 9.77783"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8889 14.2222H16.4445"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8889 18.6667H14.2222"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8889 5.33331H22"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.44446 19.5694C6.00754 20.0611 4.84466 22 4.22224 22M2.00001 19.5694C2.43693 20.0611 3.59981 22 4.22224 22M4.22224 22L4.22224 15.3333"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 4.43056C2.43692 3.9389 3.5998 2 4.22222 2M6.44445 4.43055C6.00753 3.9389 4.84465 2 4.22222 2M4.22222 2L4.22222 8.66667"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "24",
  },
  height: {
    type: [String, Number],
    default: "24",
  },
  color: {
    type: String,
    default: "#FFFFFF",
  },
  strokeWidth: {
    type: [String, Number],
    default: "1.66667",
  },
});
</script>
